// AUTO-GENERATED — do not edit by hand (regenerated by app/scripts/gen-token.sh).
//
// Holds the public POC gate value that the browser sends to /api/chat. This
// value is NOT a secret: it is bundled into the client on purpose (it only
// deters casual abuse of the demo endpoint). It must match the server-side
// POC_GATE env var.

const GENERATED_TOKEN = "464c9b9f3bf22785c44ed50a3314c35856296a8e3d0b11fb";

export const POC_TOKEN: string =
	GENERATED_TOKEN ||
	(typeof process !== "undefined" && process.env ? process.env.BUN_PUBLIC_POC_TOKEN || "" : "");
